import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-c-radio',
  templateUrl: './c-radio.component.html',
  styleUrls: ['./c-radio.component.scss']
})
export class CRadioComponent implements OnInit, ControlValueAccessor {
  @Input() value: any;
  model: any;
  onChange = (value: any) => {};
  onTouched = () => {};

  constructor(@Self() private ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    this.ngControl?.control?.valueChanges.subscribe((value) => {
      // Check to ensure the value wasn't already set (Template driven forms)
      if (this.model === value) return;
      this.writeValue(value);
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(value: any) {
    this.model = value;
  }

  //This gets called on click of the element
  select() {
    this.model = this.model === this.value ? null : this.value;
    this.onChange(this.model);
  }
}
